import React, {useMemo, useEffect, useState, useRef} from "react";

import { showToastMessageError, showToastMessageSuccess } from './toast';
import {prepararUrl, estaVacio, Rut, Error, toastOption} from '../_helpers';
import {toast} from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Inscripcion from './formularios/inscripcion';
import Actividad from './formularios/actividad';
import Establecimiento from './formularios/establecimiento';
import Final from './formularios/final';
import ModalEvento from './formularios/eventos';
import logo from './img/logo2023.png';
import fondo from './img/adm2024.jpg';


const initialState = {

    nombres: "",
    celular: "", 
    telefono_fijo: "", 
    mail: "", 
    cargo: "",
    colegio:"",
    colegio_iqq: "",
    colegio_ah: "",
    colegio_otra_comuna: "",
    colegio_otro_establecimiento: "",  
    actividad: "",
    cantidad_visitantes: "",
    fecha_inicio: "",
    horario_inicio: "",
    fecha_termino:"",
    horario_termino: ""

}

export default function Home (props) {

    const [etapas, setEtapas] = useState(1);
    const [state, setState] = useState(initialState);
    const [colegioIquique, setColegioIquique] = useState([{codcol: 107, nombre: 'LICEO LIBERTADOR GRAL BERNARDO O HIGGINS'},{codcol: 110, nombre: 'ESCUELA DOMINGO SANTA MARIA'}]);
    const [colegioAltoHospicio, setColegioAlotHospicio] = useState([{codcol: 107, nombre: 'LICEO LIBERTADOR GRAL BERNARDO O HIGGINS'},{codcol: 110, nombre: 'ESCUELA DOMINGO SANTA MARIA'}]);
    const [colegioOtrasComunas, setColegioOtrasComunas] = useState([{codcol: 107, nombre: 'LICEO LIBERTADOR GRAL BERNARDO O HIGGINS'},{codcol: 110, nombre: 'ESCUELA DOMINGO SANTA MARIA'}]);
    const [actividadesAdmision, setActividadesAdmision] = useState([{codact: 100, nombre: 'Charla Oferta Academica que ofrece el CFT Estatal de Tarapaca.'}, {codact: 101, nombre: 'Charla Gratuidad y Beneficios Estudiantiles para la Educacion Superiro.' }]);
    const [error, setError] = useState({});
    const [guardando, setGuardando] = useState(false);
    const [modal, setModal] = useState(false);
    const [visible, setVisible] = useState("Mostrar");
    const [stateEncontrado, setStateEncontrado] = useState(false);
    const [abrirInstructivo, setAbrirInstructivo] =useState(false);

    const [desactivaCondicones, setDesactivaCondiciones] = useState(1);
    const [CheckedCondiciones, setIsChecked] = useState(false);


    useEffect(() =>{
        buscarColegios();

    },[]);

    useEffect(() =>{
        _buscarActividad();

    },[state.actividad]);

    const toggleVisibility = () => {
        setVisible(!visible);
    };

    const handleChangeError = name => {              
        if(name in error){
            delete error[name];
        }
    }

    const _handleChangeSoloNum = (e) => {
        const { name, value } = e.target;
        const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
        setState((prevState) => ({
            ...prevState,
            [name]: removeNonNumeric(value)
        }));
      };

    const handleChangeChbxCondiciones = event => {
        
        setIsChecked(event.target.checked);

        if(event.target.checked === false) {
            setDesactivaCondiciones(1);
        } 
        else if(event.target.checked === true) {
            setDesactivaCondiciones(2);
        }
    };

    const correo = async() =>{

        try {
            
            const requestOptions = { 
                method: 'POST',
                body:  JSON.stringify(state)
            };

            let v_url = prepararUrl("solicitud_evento",'backend','solicitud_evento','3', [{name: "var1",value: state}]);
            const response = await window.fetch(v_url, requestOptions);
            const resp = await response.json();
            
            if(response.ok){
                
            }else{
                if(response.status===400){
                    
                    showToastMessageError(resp.message);                           
                }
                if(response.status===401){
                    showToastMessageError(resp.message);
                }
            }            
        }
        catch(error){
            console.error('Error:', error);
        };

    }

    const buscarColegios = async  () =>{

        try {
            const requestOptions = {
                method: 'GET'   
            };
            let v_url = prepararUrl("solicitud_evento",'backend','solicitud_evento','1', []);
            const response = await window.fetch(v_url, requestOptions);
            const resp = await response.json();
            
            if(response.ok){

                setColegioIquique(resp.lista_iqq);
                setColegioAlotHospicio(resp.lista_ah);
                setColegioOtrasComunas(resp.lista_ot);
                setActividadesAdmision(resp.lista_act);
                
            }else{
                if(response.status===400){
                    
                    showToastMessageError(resp.message);                           
                }
                if(response.status===401){
                    showToastMessageError(resp.message);
                }
            }            
        }
        catch(error){
            console.error('Error:', error);
        };
    } 

    
    async function _handleClickGuardarActividad() {
        
        if(etapas == 3){
            if (!validateFormActividad()) {
                showToastMessageError('Verifique campos');
                return false;
            }
        }

        setGuardando(true);
         
        const requestOptions = {
            method: 'POST',
            body:  JSON.stringify({solicitud_ev: state })
        }; 

        try{

            let v_url = prepararUrl("solicitud_evento","backend","solicitud_evento",'2',[]);
            const response = await window.fetch(v_url, requestOptions);
            const resp = await response.json();
            if(response.ok){
                if(resp.ok == "ok"){

                    setModal(true);
                    setEtapas(4);
                    setGuardando(false);
                    showToastMessageSuccess("Su información fue enviada exitosamente");
                }
            }
            else{
                if(resp.code===401){
                    toast(Error.error401, toastOption({type: "error"}));
                    setGuardando(false);

                }
                else if(resp.code===400){
                    toast(resp.error, toastOption({type: "error"}));
                    setGuardando(false);
                } 
            } 
        }
        catch(error){
            toast(Error.errorUnknown, toastOption({type: "error"}));
            setGuardando(false);
        }   
            
    }

    function _buscarActividad(){

        let v_actividad = state.actividad;
        let formValid = false;

        for(let i=0; actividadesAdmision.length > i; i++){
            if(actividadesAdmision[i].id == Number(v_actividad)){
                if(actividadesAdmision[i].nombre == "Visita al CFT Estatal de Tarapacá"){
                    formValid = true;
                }
            }
        }
        if(!formValid){
            setState((prevState) => ({
                ...prevState,
                cantidad_visitantes: ""
            }))
        }
        setStateEncontrado(formValid);        
    }

    const _handleOnChangeText = e =>{
        
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));

        if(name == "colegio_iqq"){
            setState((prevState) =>({
                ...prevState,
                colegio_ah: "",
                colegio_otra_comuna: "",
                colegio_otro_establecimiento: "",
                colegio: "CIQQ"
            }))
            delete error["colegio_ah"];
            delete error["colegio_otra_comuna"];
            delete error["colegio_otro_establecimiento"];

        }
        if(name == "colegio_ah"){
            setState((prevState) =>({
                ...prevState,
                colegio_iqq: "",
                colegio_otra_comuna: "",
                colegio_otro_establecimiento: "",
                colegio: "CAH"
            }))
            delete error["colegio_iqq"];
            delete error["colegio_otra_comuna"];
            delete error["colegio_otro_establecimiento"];
        }
        if(name == "colegio_otra_comuna"){
            setState((prevState) =>({
                ...prevState,
                colegio_ah: "",
                colegio_iqq: "",
                colegio_otro_establecimiento: "",
                colegio: "COC"
            }))
            delete error["colegio_ah"];
            delete error["colegio_iqq"];
            delete error["colegio_otro_establecimiento"];
        }
        if(name == "colegio_otro_establecimiento"){
            setState((prevState) =>({
                ...prevState,
                colegio_iqq: "",
                colegio_otra_comuna: "",
                colegio_iqq: "",
                colegio: "COE"
            }))
            delete error["colegio_ah"];
            delete error["colegio_otra_comuna"];
            delete error["colegio_iqq"];
        }

        handleChangeError(name);
    }
    
    function isValidEmail(mail) {
        return /\S+@\S+\.\S+/.test(mail);
    }

    const validateFormInscripcion = () => {
        let field = state;
        let error = {};
        let formValid = true;

        if(!field.nombres){
            formValid=false;
            error["nombres"] = "Ingrese Nombre Completo.";   
        }
        if(!field.celular){
            formValid=false;
            error["celular"] = "Ingrese Celular.";   
        }
        if(!field.mail){
            formValid=false;
            error["mail"] = "Ingrese Correo Electronico.";   
        }
        else
        {
            if(!isValidEmail(field.mail)){
                formValid=false;
                error["mail"] = "Correo inválido";
            }
        }

        setError(error);
        return formValid;

    }

    const validateFormContacto = () => {

        let field = state;
        let error = {};
        let formValid = true;

        if(!field.colegio_iqq && !field.colegio_ah && !field.colegio_otro_establecimiento && !field.colegio_otra_comuna){
            formValid=false;
            error["colegio_iqq"] = "Seleccione Establecimiento.";     
            error["colegio_ah"] = "Seleccione Establecimiento.";   
            error["colegio_otro_establecimiento"] = "Seleccione Establecimiento.";   
            error["colegio_otra_comuna"] = "Seleccione Establecimiento.";           
        }

        setError(error);
        return formValid;

    }

    const validateFormActividad = () => {

        let field = state;
        let error = {};
        let formValid = true;

        if(!field.actividad){
            formValid=false;
            error["actividad"] = "Seleccione Actividad.";             
        }
        if(!field.fecha_inicio){
            formValid=false;
            error["fecha_inicio"] = "Seleccione Fecha Inicio.";             
        }
        if(!field.horario_inicio){
            formValid=false;
            error["horario_inicio"] = "Seleccione Horario Inicio.";             
        }
        if(!field.fecha_termino){
            formValid=false;
            error["fecha_termino"] = "Seleccione Fecha Termino.";             
        }
        if(!field.horario_termino){
            formValid=false;
            error["horario_termino"] = "Seleccione Horario Termino.";             
        }

        setError(error);
        return formValid;
    }
    

    function SiguienteEtapa () { 
        
        if (etapas === 1) {
            if (!validateFormInscripcion()) {
                showToastMessageError('Verifique campos');
                return false;
            }
        }
        if (etapas === 2) {
            if (!validateFormContacto()) {
                showToastMessageError('Verifique campos');
                return false;
            }
        }
        if (etapas === 3) {
            if (!validateFormActividad()) {
                showToastMessageError('Verifique campos');
                return false;
            }
        }
        setEtapas(etapas+1);
    }

    function DevolverEtapa () { 
        setEtapas(etapas-1);
    }

    function Porcentaje () {
        if (etapas === 1) {
            return "0%";
        }
        
        else if (etapas === 2) {
            return "40%";
        }

        else if (etapas === 3) {
            return "80%";
        }

        else if (etapas === 4) {
            return "100%";
        }
    }

    function HabilitaCondiciones () {
        if (desactivaCondicones === 1) {
            return "disabled";
        }
        else {
            return "";
        }
    }
    function showInstructivo (){
        setAbrirInstructivo(true);
    }
    function cerrarInstructivo (){
        setAbrirInstructivo(false);
    }

    const BntAyuda = () => {
        return(<>
        <div className='col-auto me-auto'>
            <button type="button" className="btn btn-sm btn-warning" onClick={showInstructivo}>
                <FontAwesomeIcon icon="fa-solid fa-circle-question" className="me-1"/>Ayuda
            </button>
        </div>
        </>)
    }
    const BtnAtras = () => {
        return(<>
            <div className='col-auto'>
                <button type="button" className="btn btn-sm btn-light" onClick={DevolverEtapa} >
                    <FontAwesomeIcon icon="fa-solid fa-arrow-left" className="me-1"/>Atrás
                </button>
            </div>
        </>)
    }

    const BtnSiguiente = () => {

        return(<>
            <button type="button" className="btn btn-sm btn-primary" onClick={SiguienteEtapa} >
                <FontAwesomeIcon icon="fa-solid fa-arrow-right" className="me-1"/>Siguiente
            </button>
        </>)
    }

    const BtnEnviar = () => {
        return(
            <button type="button" className="btn btn-sm btn-primary" disabled={guardando || HabilitaCondiciones ()}
            onClick={() => _handleClickGuardarActividad()}>
                <FontAwesomeIcon icon="fa-solid fa-paper-plane" className="me-1" />
                {guardando? "Enviando..." : "Enviar"}
            </button>
        )
    }

    const ModalFinal = () => {

        return(
            <div>
                {modal ? <ModalEvento /> :""}
            </div>
        )
    }
    const ChkCondiciones = () => {
        return(<>
            <input className="form-check-input" type="checkbox" id="condiciones" name="condiciones" onChange={handleChangeChbxCondiciones} checked={CheckedCondiciones}/>
            &nbsp;&nbsp;Acepto que conforme a lo estipulado en la ley N°19.628 autorizo al almacenamiento de datos personales y su utilización en lo que la entidad estime pertinente, en resguardo siempre de la vida privada de los involucrados.
        </>)
    }

    var sectionStyle = {
        backgroundSize: "cover",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${fondo})`
    };

    return(
        <>
        {visible && (
        <>
        <div className="min-vh-100 min-vw-100" style={sectionStyle}>
            <div className="row">
                <div className="col-12 col-sm-5 mt-2">
                    <div className="card bg-transparent text-white mt-4">
                        <div className="card-body text-center" style={{marginTop: "20%"}}>
                            <h1 className="card-title"><b>Ciclo de Actividades</b></h1>
                            <h4 className="card-text">¡Ya puedes reservar tu cupo para realizar actividades con nosotros!</h4>
                        </div>
                    </div>
                    {abrirInstructivo ?
                        <div className="alert alert-primary d-flex align-items-center ms-3" role="alert">
                            <div className="col-12">
                                <div className="d-flex justify-content-between"><strong>Instructivo</strong><button type="button" className="btn-close" onClick={cerrarInstructivo} aria-label="Close"></button></div>
                                <div>1. Completar y verificar que los campos <strong>obligatorios</strong> estén correctamente ingresados.</div>
                                <div>2. Utilizar el botón <strong>Siguiente</strong> para avanzar con el formulario sección por sección.</div>
                                <div>3. Dentro la sección de Actividad <strong>lea</strong> y <strong>acepte</strong> términos antes de enviar el formulario.</div>
                            </div>
                        </div>
                        : ""
                    } 
                </div>
                
                <div className="col-12 col-sm-6">
                    <div className="card mt-4">
                        <div className="card-body">
                            <div className="text-center mb-3">
                                <img src={logo} width="220px" height="170px"/>
                                <h4 className="card-title">Proceso de Actividades 2024</h4>
                                <h5 className="card-title fst-italic">Registro de Actividades de Difusión CFT Estatal Tarapacá</h5>
                            </div>
                            <div className="card-text">
                                <div className="progress custom-progress-bar mb-3">
                                    <div className="progress-bar" role="progressbar" style={{ width: Porcentaje() }} aria-valuenow="0"
                                        aria-valuemin="0" aria-valuemax="100" >
                                    </div>
                                </div>
                                    {(etapas === 1) && <Inscripcion state = {state} 
                                        handleOnChangeText = {_handleOnChangeText} 
                                        handleChangeSoloNum={_handleChangeSoloNum} 
                                        error = {error}/> }
                                    {(etapas === 2) && <Establecimiento state = {state} 
                                        handleOnChangeText = {_handleOnChangeText} 
                                        colegioIquique = {colegioIquique} 
                                        colegioAltoHospicio = {colegioAltoHospicio} 
                                        colegioOtrasComunas = {colegioOtrasComunas} 
                                        error = {error} />}
                                    {(etapas === 3) && <Actividad state ={state} 
                                        handleOnChangeText = {_handleOnChangeText} 
                                        actividadesAdmision = {actividadesAdmision} 
                                        handleChangeSoloNum ={_handleChangeSoloNum}
                                        stateEncontrado = {stateEncontrado}
                                        error = {error} />}
                                    {(etapas === 4) && <Final /> }
                                        
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        {(etapas === 3) && <ChkCondiciones />}
                                    </div>
                                </div>
                                <div className='row g-1 d-flex'>
                                    
                                    {(etapas > 0 && etapas <= 3) && <BntAyuda />}
                                    {(etapas > 1 && etapas <= 3) && <BtnAtras />}
                                    <div className='col-auto '>
                                        {(etapas === 3) ? <BtnEnviar /> : <> {(etapas <= 3) ? <BtnSiguiente /> : ""}</>
                                        }
                                    </div>
                                </div>
                                <div>
                                    {(etapas === 4) ?  <ModalFinal /> : ""  }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)}
    
    {/*(etapas === 4) && <Final state = {state} /> */}

    </>
    );
    
}